import React, { Suspense } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { NavBar,Skeleton } from 'antd-mobile'
export default function Letusign() {
  const navigate = useNavigate()
  return (
    <Suspense fallback={
        <>
          <Skeleton.Title animated />
          <Skeleton.Paragraph lineCount={5} animated />
        </>
      }
    >
      <NavBar 
        className='crm-header' 
        onBack={()=>navigate(-1)}
      >
        意数电子签
      </NavBar>
      <Outlet/>
    </Suspense>
  )
}